import script from "./GrCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./GrCard.vue?vue&type=script&setup=true&lang=ts"

import "./GrCard.vue?vue&type=style&index=0&id=ddc806d2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ddc806d2"]])

export default __exports__